import { axios } from "@Root/API";

export const putAdminAwardingBody = ({ id, name }) => {
  return axios.put(`edit/program-awarding-body/${id}`, { name });
};
